// Util/goBack.js
// "Cancel" / "Back" that never strands the user: with in-app history it goes
// back as before; opened fresh (new tab, deep link, bookmark) it goes to the
// page's parent list instead of leaving the app or doing nothing.
//   parentPath("/saleschallan/update/52") → "/saleschallan"
//   parentPath("/qrinwardregister/details/9/print") → "/qrinwardregister"

const ACTION_SEGMENTS = new Set([
    "add", "new", "create", "update", "edit", "amend", "detail", "details", "view",
    "print", "receive", "approve", "verify", "clone", "duplicate",
]);

const isIdLike = (seg) => /^\d+$/.test(seg) || /^[0-9a-f-]{16,}$/i.test(seg);

export function parentPath(pathname = "/") {
    const segs = String(pathname).split(/[?#]/)[0].split("/").filter(Boolean);
    while (segs.length > 1 && (isIdLike(segs[segs.length - 1]) || ACTION_SEGMENTS.has(segs[segs.length - 1].toLowerCase()))) {
        segs.pop();
    }
    return segs.length ? `/${segs.join("/")}` : "/";
}

// Route changes seen in THIS app session (hooks/usePageTracking calls
// noteRouteChange). window.history.length also counts other sites' pages, so a
// tab opened from a WhatsApp link went "back" out of the ERP; and a fresh deep
// link with length 1 did nothing.
let routesSeen = 0;
export const noteRouteChange = () => { routesSeen += 1; };

export default function goBack(history, fallback) {
    if (routesSeen > 1) {
        history.goBack();
    } else {
        history.push(fallback || parentPath(history.location?.pathname || window.location.pathname));
    }
}
